import { createContext } from 'react';

/**
 * Map of `catentryId -> free-gift promo code` (PGC / PGNC / TNC-PGC / TNC-PGNC / PG) provided by a
 * product list that batches the multi-free-gift lookup into a single request.
 *
 * `null` means there is no batching provider, so a card should resolve its own promo code.
 */
export const MultiFreeGiftPromoContext = createContext<Map<string, string> | null>(null);
